import { StaticMsgModule } from '@lib/pipes';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceRequestPaymentInputSubHeaderComponent } from './service-request-payment-input-sub-header.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ServiceRequestPaymentInputSubHeaderComponent],
  exports: [ServiceRequestPaymentInputSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule],
})
export class ServiceRequestPaymentInputSubHeaderModule {}
